import { render, staticRenderFns } from "./RegionNumberInfo.vue?vue&type=template&id=4c57f90c&scoped=true"
import script from "./RegionNumberInfo.vue?vue&type=script&lang=js"
export * from "./RegionNumberInfo.vue?vue&type=script&lang=js"
import style0 from "./RegionNumberInfo.vue?vue&type=style&index=0&id=4c57f90c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c57f90c",
  null
  
)

export default component.exports